
// @ts-nocheck


export const localeCodes =  [
  "en",
  "ar",
  "ru",
  "cs",
  "da",
  "bg",
  "nl",
  "et",
  "de",
  "uk",
  "es",
  "tr",
  "zh",
  "pt",
  "fi",
  "fr",
  "el",
  "hu",
  "id",
  "it",
  "ja",
  "ko",
  "lv",
  "lt",
  "nb",
  "pl",
  "ro",
  "sk",
  "sl",
  "sv"
]

export const localeLoaders = {
  "en": [],
  "ar": [],
  "ru": [],
  "cs": [],
  "da": [],
  "bg": [],
  "nl": [],
  "et": [],
  "de": [],
  "uk": [],
  "es": [],
  "tr": [],
  "zh": [],
  "pt": [],
  "fi": [],
  "fr": [],
  "el": [],
  "hu": [],
  "id": [],
  "it": [],
  "ja": [],
  "ko": [],
  "lv": [],
  "lt": [],
  "nb": [],
  "pl": [],
  "ro": [],
  "sk": [],
  "sl": [],
  "sv": []
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "language": "en-US"
    },
    {
      "code": "ar",
      "language": "ar-AE"
    },
    {
      "code": "ru",
      "language": "ru-RU"
    },
    {
      "code": "cs",
      "language": "cs-CS"
    },
    {
      "code": "da",
      "language": "da-DK"
    },
    {
      "code": "bg",
      "language": "bg-BG"
    },
    {
      "code": "nl",
      "language": "nl-NL"
    },
    {
      "code": "et",
      "language": "et-EE"
    },
    {
      "code": "de",
      "language": "de-DE"
    },
    {
      "code": "uk",
      "language": "uk-UA"
    },
    {
      "code": "es",
      "language": "es-ES"
    },
    {
      "code": "tr",
      "language": "tr-TR"
    },
    {
      "code": "zh",
      "language": "zh-CN"
    },
    {
      "code": "pt",
      "language": "pt-PT"
    },
    {
      "code": "fi",
      "language": "fi-FI"
    },
    {
      "code": "fr",
      "language": "fr-FR"
    },
    {
      "code": "el",
      "language": "el-GR"
    },
    {
      "code": "hu",
      "language": "hu-HU"
    },
    {
      "code": "id",
      "language": "id-ID"
    },
    {
      "code": "it",
      "language": "it-IT"
    },
    {
      "code": "ja",
      "language": "ja-JP"
    },
    {
      "code": "ko",
      "language": "ko-KR"
    },
    {
      "code": "lv",
      "language": "lv-LV"
    },
    {
      "code": "lt",
      "language": "lt-LT"
    },
    {
      "code": "nb",
      "language": "nb-NO"
    },
    {
      "code": "pl",
      "language": "pl-PL"
    },
    {
      "code": "ro",
      "language": "ro-RO"
    },
    {
      "code": "sk",
      "language": "sk-SK"
    },
    {
      "code": "sl",
      "language": "sl-SI"
    },
    {
      "code": "sv",
      "language": "sv-SV"
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_and_default",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "language": "en-US",
    "files": []
  },
  {
    "code": "ar",
    "language": "ar-AE",
    "files": []
  },
  {
    "code": "ru",
    "language": "ru-RU",
    "files": []
  },
  {
    "code": "cs",
    "language": "cs-CS",
    "files": []
  },
  {
    "code": "da",
    "language": "da-DK",
    "files": []
  },
  {
    "code": "bg",
    "language": "bg-BG",
    "files": []
  },
  {
    "code": "nl",
    "language": "nl-NL",
    "files": []
  },
  {
    "code": "et",
    "language": "et-EE",
    "files": []
  },
  {
    "code": "de",
    "language": "de-DE",
    "files": []
  },
  {
    "code": "uk",
    "language": "uk-UA",
    "files": []
  },
  {
    "code": "es",
    "language": "es-ES",
    "files": []
  },
  {
    "code": "tr",
    "language": "tr-TR",
    "files": []
  },
  {
    "code": "zh",
    "language": "zh-CN",
    "files": []
  },
  {
    "code": "pt",
    "language": "pt-PT",
    "files": []
  },
  {
    "code": "fi",
    "language": "fi-FI",
    "files": []
  },
  {
    "code": "fr",
    "language": "fr-FR",
    "files": []
  },
  {
    "code": "el",
    "language": "el-GR",
    "files": []
  },
  {
    "code": "hu",
    "language": "hu-HU",
    "files": []
  },
  {
    "code": "id",
    "language": "id-ID",
    "files": []
  },
  {
    "code": "it",
    "language": "it-IT",
    "files": []
  },
  {
    "code": "ja",
    "language": "ja-JP",
    "files": []
  },
  {
    "code": "ko",
    "language": "ko-KR",
    "files": []
  },
  {
    "code": "lv",
    "language": "lv-LV",
    "files": []
  },
  {
    "code": "lt",
    "language": "lt-LT",
    "files": []
  },
  {
    "code": "nb",
    "language": "nb-NO",
    "files": []
  },
  {
    "code": "pl",
    "language": "pl-PL",
    "files": []
  },
  {
    "code": "ro",
    "language": "ro-RO",
    "files": []
  },
  {
    "code": "sk",
    "language": "sk-SK",
    "files": []
  },
  {
    "code": "sl",
    "language": "sl-SI",
    "files": []
  },
  {
    "code": "sv",
    "language": "sv-SV",
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
